import _ from "lodash";

import { AssessmentEnum } from "@/core/constants";

export const getMemberAssessmentType = (profile) => {
  const default_assessment = _.get(profile, "assessment_config.default_assessment", false);

  if (default_assessment) {
    return default_assessment;
  }

  return _.get(profile, "assessment_config.assessment_type", AssessmentEnum.A5_V2_ASSESSMENT_TYPE);
};
